let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bVjPW")).then(() => parcelRequire('ca8zp'));